import { render, staticRenderFns } from "./CategoryTableAllType.vue?vue&type=template&id=329c54c2&scoped=true"
import script from "./CategoryTableAllType.vue?vue&type=script&lang=js"
export * from "./CategoryTableAllType.vue?vue&type=script&lang=js"
import style0 from "./CategoryTableAllType.vue?vue&type=style&index=0&id=329c54c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329c54c2",
  null
  
)

export default component.exports